import { Typography } from "@mui/material";

export interface ISmsModalDescriptionWarningProps {
  candidatesCount: number;
  eligibleCandidatesCount: number;
}

export const SmsModalDescriptionWarning = ({
  candidatesCount,
  eligibleCandidatesCount,
}: ISmsModalDescriptionWarningProps) => {
  if (candidatesCount > 1) {
    const deltaCount = candidatesCount - eligibleCandidatesCount;
    if (deltaCount > 1) {
      return (
        <Typography variant="body1" color="secondary">
          Vous avez sélectionné {candidatesCount} candidats afin de leur envoyer un SMS. Cependant {deltaCount} d’entre
          eux n’ont pas de numéro de téléphone ou n’ont pas accepté ce mode de contact. Seuls les candidats remplissant
          les conditions d’envoi recevront le sms.
        </Typography>
      );
    }
    return (
      <Typography variant="body1" color="secondary">
        Vous avez sélectionné {candidatesCount} candidats afin de leur envoyer un SMS. Cependant un d’entre eux n’a pas
        de numéro de téléphone ou n’a pas accepté ce mode de contact. Seuls les candidats remplissant les conditions
        d’envoi recevront le sms.
      </Typography>
    );
  }
  return (
    <Typography variant="body1" color="secondary">
      Vous avez sélectionné un candidat afin de lui envoyer un SMS. Cependant celui-ci n'a pas de numéro de téléphone ou
      n'a pas accepté ce mode de contact. Seul un candidat remplissant les conditions d’envoi peut recevoir un SMS.
    </Typography>
  );
};
